import { FaBed, FaWheelchair } from "react-icons/fa";
import { Incubator } from "../FigmaIcons/Incubator";

export const LANGUAGES = [
  { label: "Spanish", code: "es" },
  { label: "English", code: "en" },
];

export const EQUIPMENT_MAP = {
  wheel_chair: <FaWheelchair size={28} color="#2C4861" />,
  trolley: <FaBed size={28} color="#2C4861" />,
  incubator: <Incubator />,
};

export const TRIP_STATUS = {
  SHIFTER_ACCEPTED: "shifter_accepted",
  EQUIPMENT_COLLECTION: "equipment_collected",
  AT_PICKUP_POINT: "at_pickup_point",
  STARTED_SHIFTING: "started_shifting",
  COMPLETE: "complete",
  AT_DESTINATION: "at_destination",
  DESTINATION_COVERED: "destinations_covered",
  CANCELED: "canceled",
  BOOKED: "booked",
  SHIFTER_ASSIGNED: "shifter_assigned",
};

export const SHIFTER_STATUS = {
  ON_BREAK: "on_break",
  ON_SPECIAL_DUTY: "on_special_duty",
  ON_TRIP: "on_trip",
};

export const getProgressTemplate = (destinationDetails) => {
  const isSingleDestination = destinationDetails?.length === 1;
  return [
    {
      id: 1,
      name: "Equipment Collection",
      buttonName: "Equipment collected",
      status: TRIP_STATUS.EQUIPMENT_COLLECTION,
      prevStatus: TRIP_STATUS.SHIFTER_ACCEPTED,
    },
    {
      id: 2,
      name: "At pickup",
      buttonName: "At pickup",
      status: TRIP_STATUS.AT_PICKUP_POINT,
      prevStatus: TRIP_STATUS.EQUIPMENT_COLLECTION,
    },
    {
      id: 3,
      name: "Started Shifting",
      buttonName: "Started shifting",
      status: TRIP_STATUS.STARTED_SHIFTING,
      prevStatus: TRIP_STATUS.AT_PICKUP_POINT,
    },
    {
      id: 4,
      name: "At destination",
      buttonName: "Arrived",
      status: TRIP_STATUS.COMPLETE,
      prevStatus: isSingleDestination
        ? TRIP_STATUS.STARTED_SHIFTING
        : destinationDetails.some((d) => d.status === TRIP_STATUS.COMPLETE)
        ? TRIP_STATUS.AT_DESTINATION
        : TRIP_STATUS.STARTED_SHIFTING,
    },
    {
      id: 5,
      name: "Trip Completed",
      buttonName: "Trip completed",
      status: TRIP_STATUS.COMPLETE,
      prevStatus: TRIP_STATUS.DESTINATION_COVERED,
    },
  ];
};

export const getProgressTemplateGeneric = (destinationDetails) => {
  const isSingleDestination = destinationDetails?.length === 1;
  return [
    {
      id: 1,
      name: "At pickup",
      buttonName: "At pickup",
      status: TRIP_STATUS.AT_PICKUP_POINT,
      prevStatus: TRIP_STATUS.SHIFTER_ACCEPTED,
    },
    {
      id: 2,
      name: "Started Shifting",
      buttonName: "Started shifting",
      status: TRIP_STATUS.STARTED_SHIFTING,
      prevStatus: TRIP_STATUS.AT_PICKUP_POINT,
    },
    {
      id: 3,
      name: "At destination",
      buttonName: "Arrived",
      status: TRIP_STATUS.COMPLETE,
      prevStatus: isSingleDestination
        ? TRIP_STATUS.STARTED_SHIFTING
        : destinationDetails.some((d) => d.status === TRIP_STATUS.COMPLETE)
        ? TRIP_STATUS.AT_DESTINATION
        : TRIP_STATUS.STARTED_SHIFTING,
    },
    {
      id: 4,
      name: "Trip Completed",
      buttonName: "Trip completed",
      status: TRIP_STATUS.COMPLETE,
      prevStatus: TRIP_STATUS.DESTINATION_COVERED,
    },
  ];
};
